/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var common_pb = require('./common_pb.js');
var route_plan_pb = require('./route_plan_pb.js');
var route_proposal_pb = require('./route_proposal_pb.js');
goog.exportSymbol('proto.fleet.ConfirmOvcEventRequest', null, global);
goog.exportSymbol('proto.fleet.ConfirmOvcEventResponse', null, global);
goog.exportSymbol('proto.fleet.ConfirmRouteProposalRequest', null, global);
goog.exportSymbol('proto.fleet.ConfirmRouteProposalResponse', null, global);
goog.exportSymbol('proto.fleet.GetRouteProposalRequest', null, global);
goog.exportSymbol('proto.fleet.GetRouteProposalResponse', null, global);
goog.exportSymbol('proto.fleet.ListWaypointsRequest', null, global);
goog.exportSymbol('proto.fleet.ListWaypointsResponse', null, global);
goog.exportSymbol('proto.fleet.SendPulloverRequest', null, global);
goog.exportSymbol('proto.fleet.SendPulloverResponse', null, global);
goog.exportSymbol('proto.fleet.SendWaypointRequest', null, global);
goog.exportSymbol('proto.fleet.SendWaypointResponse', null, global);
goog.exportSymbol('proto.fleet.SetAutonomyReadyRequest', null, global);
goog.exportSymbol('proto.fleet.SetAutonomyReadyResponse', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.ListWaypointsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.ListWaypointsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.ListWaypointsRequest.displayName = 'proto.fleet.ListWaypointsRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.ListWaypointsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.ListWaypointsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.ListWaypointsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ListWaypointsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vehicleId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.ListWaypointsRequest}
 */
proto.fleet.ListWaypointsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.ListWaypointsRequest;
  return proto.fleet.ListWaypointsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.ListWaypointsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.ListWaypointsRequest}
 */
proto.fleet.ListWaypointsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.ListWaypointsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.ListWaypointsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.ListWaypointsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ListWaypointsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string vehicle_id = 1;
 * @return {string}
 */
proto.fleet.ListWaypointsRequest.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.ListWaypointsRequest.prototype.setVehicleId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.ListWaypointsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.ListWaypointsResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.ListWaypointsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.ListWaypointsResponse.displayName = 'proto.fleet.ListWaypointsResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.ListWaypointsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.ListWaypointsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.ListWaypointsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.ListWaypointsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ListWaypointsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    waypointsList: jspb.Message.toObjectList(msg.getWaypointsList(),
    common_pb.WaypointDescription.toObject, includeInstance),
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.ListWaypointsResponse}
 */
proto.fleet.ListWaypointsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.ListWaypointsResponse;
  return proto.fleet.ListWaypointsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.ListWaypointsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.ListWaypointsResponse}
 */
proto.fleet.ListWaypointsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.WaypointDescription;
      reader.readMessage(value,common_pb.WaypointDescription.deserializeBinaryFromReader);
      msg.addWaypoints(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.ListWaypointsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.ListWaypointsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.ListWaypointsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ListWaypointsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWaypointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      common_pb.WaypointDescription.serializeBinaryToWriter
    );
  }
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated ori.telecomms.proto.WaypointDescription waypoints = 1;
 * @return {!Array<!proto.ori.telecomms.proto.WaypointDescription>}
 */
proto.fleet.ListWaypointsResponse.prototype.getWaypointsList = function() {
  return /** @type{!Array<!proto.ori.telecomms.proto.WaypointDescription>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.WaypointDescription, 1));
};


/** @param {!Array<!proto.ori.telecomms.proto.WaypointDescription>} value */
proto.fleet.ListWaypointsResponse.prototype.setWaypointsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ori.telecomms.proto.WaypointDescription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ori.telecomms.proto.WaypointDescription}
 */
proto.fleet.ListWaypointsResponse.prototype.addWaypoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ori.telecomms.proto.WaypointDescription, opt_index);
};


proto.fleet.ListWaypointsResponse.prototype.clearWaypointsList = function() {
  this.setWaypointsList([]);
};


/**
 * optional int32 operating_area_id = 2;
 * @return {number}
 */
proto.fleet.ListWaypointsResponse.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.ListWaypointsResponse.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.SendWaypointRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.SendWaypointRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.SendWaypointRequest.displayName = 'proto.fleet.SendWaypointRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.SendWaypointRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.SendWaypointRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.SendWaypointRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SendWaypointRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vehicleId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    waypointId: (f = msg.getWaypointId()) && common_pb.WaypointId.toObject(includeInstance, f),
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.SendWaypointRequest}
 */
proto.fleet.SendWaypointRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.SendWaypointRequest;
  return proto.fleet.SendWaypointRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.SendWaypointRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.SendWaypointRequest}
 */
proto.fleet.SendWaypointRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    case 2:
      var value = new common_pb.WaypointId;
      reader.readMessage(value,common_pb.WaypointId.deserializeBinaryFromReader);
      msg.setWaypointId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.SendWaypointRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.SendWaypointRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.SendWaypointRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SendWaypointRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWaypointId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.WaypointId.serializeBinaryToWriter
    );
  }
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string vehicle_id = 1;
 * @return {string}
 */
proto.fleet.SendWaypointRequest.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.SendWaypointRequest.prototype.setVehicleId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ori.telecomms.proto.WaypointId waypoint_id = 2;
 * @return {?proto.ori.telecomms.proto.WaypointId}
 */
proto.fleet.SendWaypointRequest.prototype.getWaypointId = function() {
  return /** @type{?proto.ori.telecomms.proto.WaypointId} */ (
    jspb.Message.getWrapperField(this, common_pb.WaypointId, 2));
};


/** @param {?proto.ori.telecomms.proto.WaypointId|undefined} value */
proto.fleet.SendWaypointRequest.prototype.setWaypointId = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.SendWaypointRequest.prototype.clearWaypointId = function() {
  this.setWaypointId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.SendWaypointRequest.prototype.hasWaypointId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 operating_area_id = 3;
 * @return {number}
 */
proto.fleet.SendWaypointRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.fleet.SendWaypointRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.SendWaypointResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.SendWaypointResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.SendWaypointResponse.displayName = 'proto.fleet.SendWaypointResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.SendWaypointResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.SendWaypointResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.SendWaypointResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SendWaypointResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.SendWaypointResponse}
 */
proto.fleet.SendWaypointResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.SendWaypointResponse;
  return proto.fleet.SendWaypointResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.SendWaypointResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.SendWaypointResponse}
 */
proto.fleet.SendWaypointResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.SendWaypointResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.SendWaypointResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.SendWaypointResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SendWaypointResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.GetRouteProposalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.GetRouteProposalRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.GetRouteProposalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.GetRouteProposalRequest.displayName = 'proto.fleet.GetRouteProposalRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.GetRouteProposalRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.GetRouteProposalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.GetRouteProposalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.GetRouteProposalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetRouteProposalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vehicleId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    waypointIdsList: jspb.Message.toObjectList(msg.getWaypointIdsList(),
    common_pb.WaypointId.toObject, includeInstance),
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    terminus: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.GetRouteProposalRequest}
 */
proto.fleet.GetRouteProposalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.GetRouteProposalRequest;
  return proto.fleet.GetRouteProposalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.GetRouteProposalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.GetRouteProposalRequest}
 */
proto.fleet.GetRouteProposalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    case 2:
      var value = new common_pb.WaypointId;
      reader.readMessage(value,common_pb.WaypointId.deserializeBinaryFromReader);
      msg.addWaypointIds(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 4:
      var value = /** @type {!proto.ori.telecomms.proto.StationType} */ (reader.readEnum());
      msg.setTerminus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.GetRouteProposalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.GetRouteProposalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.GetRouteProposalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetRouteProposalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWaypointIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      common_pb.WaypointId.serializeBinaryToWriter
    );
  }
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTerminus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string vehicle_id = 1;
 * @return {string}
 */
proto.fleet.GetRouteProposalRequest.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.GetRouteProposalRequest.prototype.setVehicleId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ori.telecomms.proto.WaypointId waypoint_ids = 2;
 * @return {!Array<!proto.ori.telecomms.proto.WaypointId>}
 */
proto.fleet.GetRouteProposalRequest.prototype.getWaypointIdsList = function() {
  return /** @type{!Array<!proto.ori.telecomms.proto.WaypointId>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.WaypointId, 2));
};


/** @param {!Array<!proto.ori.telecomms.proto.WaypointId>} value */
proto.fleet.GetRouteProposalRequest.prototype.setWaypointIdsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.ori.telecomms.proto.WaypointId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ori.telecomms.proto.WaypointId}
 */
proto.fleet.GetRouteProposalRequest.prototype.addWaypointIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.ori.telecomms.proto.WaypointId, opt_index);
};


proto.fleet.GetRouteProposalRequest.prototype.clearWaypointIdsList = function() {
  this.setWaypointIdsList([]);
};


/**
 * optional int32 operating_area_id = 3;
 * @return {number}
 */
proto.fleet.GetRouteProposalRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.fleet.GetRouteProposalRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ori.telecomms.proto.StationType terminus = 4;
 * @return {!proto.ori.telecomms.proto.StationType}
 */
proto.fleet.GetRouteProposalRequest.prototype.getTerminus = function() {
  return /** @type {!proto.ori.telecomms.proto.StationType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.ori.telecomms.proto.StationType} value */
proto.fleet.GetRouteProposalRequest.prototype.setTerminus = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.GetRouteProposalResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.GetRouteProposalResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.GetRouteProposalResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.GetRouteProposalResponse.displayName = 'proto.fleet.GetRouteProposalResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.GetRouteProposalResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.GetRouteProposalResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.GetRouteProposalResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.GetRouteProposalResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetRouteProposalResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    header: (f = msg.getHeader()) && common_pb.ControlCommandHeader.toObject(includeInstance, f),
    result: jspb.Message.getFieldWithDefault(msg, 2, 0),
    waypointsList: jspb.Message.toObjectList(msg.getWaypointsList(),
    common_pb.WaypointDescription.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.GetRouteProposalResponse}
 */
proto.fleet.GetRouteProposalResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.GetRouteProposalResponse;
  return proto.fleet.GetRouteProposalResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.GetRouteProposalResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.GetRouteProposalResponse}
 */
proto.fleet.GetRouteProposalResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.ControlCommandHeader;
      reader.readMessage(value,common_pb.ControlCommandHeader.deserializeBinaryFromReader);
      msg.setHeader(value);
      break;
    case 2:
      var value = /** @type {!proto.ori.telecomms.proto.RouteProposal.RoutePlanResult} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 3:
      var value = new common_pb.WaypointDescription;
      reader.readMessage(value,common_pb.WaypointDescription.deserializeBinaryFromReader);
      msg.addWaypoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.GetRouteProposalResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.GetRouteProposalResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.GetRouteProposalResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetRouteProposalResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHeader();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.ControlCommandHeader.serializeBinaryToWriter
    );
  }
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getWaypointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.WaypointDescription.serializeBinaryToWriter
    );
  }
};


/**
 * optional ori.telecomms.proto.ControlCommandHeader header = 1;
 * @return {?proto.ori.telecomms.proto.ControlCommandHeader}
 */
proto.fleet.GetRouteProposalResponse.prototype.getHeader = function() {
  return /** @type{?proto.ori.telecomms.proto.ControlCommandHeader} */ (
    jspb.Message.getWrapperField(this, common_pb.ControlCommandHeader, 1));
};


/** @param {?proto.ori.telecomms.proto.ControlCommandHeader|undefined} value */
proto.fleet.GetRouteProposalResponse.prototype.setHeader = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.fleet.GetRouteProposalResponse.prototype.clearHeader = function() {
  this.setHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.GetRouteProposalResponse.prototype.hasHeader = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ori.telecomms.proto.RouteProposal.RoutePlanResult result = 2;
 * @return {!proto.ori.telecomms.proto.RouteProposal.RoutePlanResult}
 */
proto.fleet.GetRouteProposalResponse.prototype.getResult = function() {
  return /** @type {!proto.ori.telecomms.proto.RouteProposal.RoutePlanResult} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.ori.telecomms.proto.RouteProposal.RoutePlanResult} value */
proto.fleet.GetRouteProposalResponse.prototype.setResult = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated ori.telecomms.proto.WaypointDescription waypoints = 3;
 * @return {!Array<!proto.ori.telecomms.proto.WaypointDescription>}
 */
proto.fleet.GetRouteProposalResponse.prototype.getWaypointsList = function() {
  return /** @type{!Array<!proto.ori.telecomms.proto.WaypointDescription>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.WaypointDescription, 3));
};


/** @param {!Array<!proto.ori.telecomms.proto.WaypointDescription>} value */
proto.fleet.GetRouteProposalResponse.prototype.setWaypointsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.ori.telecomms.proto.WaypointDescription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ori.telecomms.proto.WaypointDescription}
 */
proto.fleet.GetRouteProposalResponse.prototype.addWaypoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.ori.telecomms.proto.WaypointDescription, opt_index);
};


proto.fleet.GetRouteProposalResponse.prototype.clearWaypointsList = function() {
  this.setWaypointsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.ConfirmRouteProposalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.ConfirmRouteProposalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.ConfirmRouteProposalRequest.displayName = 'proto.fleet.ConfirmRouteProposalRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.ConfirmRouteProposalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.ConfirmRouteProposalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.ConfirmRouteProposalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ConfirmRouteProposalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vehicleId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    header: (f = msg.getHeader()) && common_pb.ControlCommandHeader.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.ConfirmRouteProposalRequest}
 */
proto.fleet.ConfirmRouteProposalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.ConfirmRouteProposalRequest;
  return proto.fleet.ConfirmRouteProposalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.ConfirmRouteProposalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.ConfirmRouteProposalRequest}
 */
proto.fleet.ConfirmRouteProposalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    case 2:
      var value = new common_pb.ControlCommandHeader;
      reader.readMessage(value,common_pb.ControlCommandHeader.deserializeBinaryFromReader);
      msg.setHeader(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.ConfirmRouteProposalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.ConfirmRouteProposalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.ConfirmRouteProposalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ConfirmRouteProposalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHeader();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.ControlCommandHeader.serializeBinaryToWriter
    );
  }
};


/**
 * optional string vehicle_id = 1;
 * @return {string}
 */
proto.fleet.ConfirmRouteProposalRequest.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.ConfirmRouteProposalRequest.prototype.setVehicleId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ori.telecomms.proto.ControlCommandHeader header = 2;
 * @return {?proto.ori.telecomms.proto.ControlCommandHeader}
 */
proto.fleet.ConfirmRouteProposalRequest.prototype.getHeader = function() {
  return /** @type{?proto.ori.telecomms.proto.ControlCommandHeader} */ (
    jspb.Message.getWrapperField(this, common_pb.ControlCommandHeader, 2));
};


/** @param {?proto.ori.telecomms.proto.ControlCommandHeader|undefined} value */
proto.fleet.ConfirmRouteProposalRequest.prototype.setHeader = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.ConfirmRouteProposalRequest.prototype.clearHeader = function() {
  this.setHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.ConfirmRouteProposalRequest.prototype.hasHeader = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.ConfirmRouteProposalResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.ConfirmRouteProposalResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.ConfirmRouteProposalResponse.displayName = 'proto.fleet.ConfirmRouteProposalResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.ConfirmRouteProposalResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.ConfirmRouteProposalResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.ConfirmRouteProposalResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ConfirmRouteProposalResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.ConfirmRouteProposalResponse}
 */
proto.fleet.ConfirmRouteProposalResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.ConfirmRouteProposalResponse;
  return proto.fleet.ConfirmRouteProposalResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.ConfirmRouteProposalResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.ConfirmRouteProposalResponse}
 */
proto.fleet.ConfirmRouteProposalResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.ConfirmRouteProposalResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.ConfirmRouteProposalResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.ConfirmRouteProposalResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ConfirmRouteProposalResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.SetAutonomyReadyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.SetAutonomyReadyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.SetAutonomyReadyRequest.displayName = 'proto.fleet.SetAutonomyReadyRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.SetAutonomyReadyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.SetAutonomyReadyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.SetAutonomyReadyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SetAutonomyReadyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vehicleId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.SetAutonomyReadyRequest}
 */
proto.fleet.SetAutonomyReadyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.SetAutonomyReadyRequest;
  return proto.fleet.SetAutonomyReadyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.SetAutonomyReadyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.SetAutonomyReadyRequest}
 */
proto.fleet.SetAutonomyReadyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.SetAutonomyReadyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.SetAutonomyReadyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.SetAutonomyReadyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SetAutonomyReadyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string vehicle_id = 1;
 * @return {string}
 */
proto.fleet.SetAutonomyReadyRequest.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.SetAutonomyReadyRequest.prototype.setVehicleId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.SetAutonomyReadyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.SetAutonomyReadyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.SetAutonomyReadyResponse.displayName = 'proto.fleet.SetAutonomyReadyResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.SetAutonomyReadyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.SetAutonomyReadyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.SetAutonomyReadyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SetAutonomyReadyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.SetAutonomyReadyResponse}
 */
proto.fleet.SetAutonomyReadyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.SetAutonomyReadyResponse;
  return proto.fleet.SetAutonomyReadyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.SetAutonomyReadyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.SetAutonomyReadyResponse}
 */
proto.fleet.SetAutonomyReadyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.SetAutonomyReadyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.SetAutonomyReadyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.SetAutonomyReadyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SetAutonomyReadyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.ConfirmOvcEventRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.ConfirmOvcEventRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.ConfirmOvcEventRequest.displayName = 'proto.fleet.ConfirmOvcEventRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.ConfirmOvcEventRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.ConfirmOvcEventRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.ConfirmOvcEventRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ConfirmOvcEventRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vehicleId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    header: (f = msg.getHeader()) && common_pb.ControlCommandHeader.toObject(includeInstance, f),
    confirmOvc: jspb.Message.getFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.ConfirmOvcEventRequest}
 */
proto.fleet.ConfirmOvcEventRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.ConfirmOvcEventRequest;
  return proto.fleet.ConfirmOvcEventRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.ConfirmOvcEventRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.ConfirmOvcEventRequest}
 */
proto.fleet.ConfirmOvcEventRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    case 2:
      var value = new common_pb.ControlCommandHeader;
      reader.readMessage(value,common_pb.ControlCommandHeader.deserializeBinaryFromReader);
      msg.setHeader(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConfirmOvc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.ConfirmOvcEventRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.ConfirmOvcEventRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.ConfirmOvcEventRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ConfirmOvcEventRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHeader();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.ControlCommandHeader.serializeBinaryToWriter
    );
  }
  f = message.getConfirmOvc();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string vehicle_id = 1;
 * @return {string}
 */
proto.fleet.ConfirmOvcEventRequest.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.ConfirmOvcEventRequest.prototype.setVehicleId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ori.telecomms.proto.ControlCommandHeader header = 2;
 * @return {?proto.ori.telecomms.proto.ControlCommandHeader}
 */
proto.fleet.ConfirmOvcEventRequest.prototype.getHeader = function() {
  return /** @type{?proto.ori.telecomms.proto.ControlCommandHeader} */ (
    jspb.Message.getWrapperField(this, common_pb.ControlCommandHeader, 2));
};


/** @param {?proto.ori.telecomms.proto.ControlCommandHeader|undefined} value */
proto.fleet.ConfirmOvcEventRequest.prototype.setHeader = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.ConfirmOvcEventRequest.prototype.clearHeader = function() {
  this.setHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.ConfirmOvcEventRequest.prototype.hasHeader = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool confirm_ovc = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.ConfirmOvcEventRequest.prototype.getConfirmOvc = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.fleet.ConfirmOvcEventRequest.prototype.setConfirmOvc = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.ConfirmOvcEventResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.ConfirmOvcEventResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.ConfirmOvcEventResponse.displayName = 'proto.fleet.ConfirmOvcEventResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.ConfirmOvcEventResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.ConfirmOvcEventResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.ConfirmOvcEventResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ConfirmOvcEventResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.ConfirmOvcEventResponse}
 */
proto.fleet.ConfirmOvcEventResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.ConfirmOvcEventResponse;
  return proto.fleet.ConfirmOvcEventResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.ConfirmOvcEventResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.ConfirmOvcEventResponse}
 */
proto.fleet.ConfirmOvcEventResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.ConfirmOvcEventResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.ConfirmOvcEventResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.ConfirmOvcEventResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ConfirmOvcEventResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.SendPulloverRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.SendPulloverRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.SendPulloverRequest.displayName = 'proto.fleet.SendPulloverRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.SendPulloverRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.SendPulloverRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.SendPulloverRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SendPulloverRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vehicleId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    confirmPullover: jspb.Message.getFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.SendPulloverRequest}
 */
proto.fleet.SendPulloverRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.SendPulloverRequest;
  return proto.fleet.SendPulloverRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.SendPulloverRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.SendPulloverRequest}
 */
proto.fleet.SendPulloverRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConfirmPullover(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.SendPulloverRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.SendPulloverRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.SendPulloverRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SendPulloverRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfirmPullover();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string vehicle_id = 1;
 * @return {string}
 */
proto.fleet.SendPulloverRequest.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.SendPulloverRequest.prototype.setVehicleId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool confirm_pullover = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.SendPulloverRequest.prototype.getConfirmPullover = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.fleet.SendPulloverRequest.prototype.setConfirmPullover = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.SendPulloverResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.SendPulloverResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.SendPulloverResponse.displayName = 'proto.fleet.SendPulloverResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.SendPulloverResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.SendPulloverResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.SendPulloverResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SendPulloverResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.SendPulloverResponse}
 */
proto.fleet.SendPulloverResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.SendPulloverResponse;
  return proto.fleet.SendPulloverResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.SendPulloverResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.SendPulloverResponse}
 */
proto.fleet.SendPulloverResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.SendPulloverResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.SendPulloverResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.SendPulloverResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.SendPulloverResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.fleet);
